import {
  ButtonVariantType,
  IconVariant,
  MolsonButton,
  MolsonTypography
} from '@components/reusable'

import type { SxProps } from '@mui/material'
import type { ReactNode } from 'react'

export const OpenItemInfo = ({
  text,
  icon,
  onClick,
  customSx,
  btnVariant = 'linkButton',
  children
}: {
  text: string
  icon?: IconVariant
  onClick: () => void
  customSx?: SxProps
  btnVariant?: ButtonVariantType
  children?: ReactNode
}) => {
  return (
    <MolsonButton
      variant={btnVariant}
      onClick={onClick}
      sx={{
        width: '100%',
        justifyContent: 'flex-start',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        textAlign: 'start',
        borderRadius: 0,
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'none'
        },
        ...customSx
      }}
    >
      <MolsonTypography
        title={text}
        variant="body1"
        fontWeight={700}
        sx={{
          textDecoration: 'underline',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 1,
          WebkitBoxOrient: 'vertical'
        }}
      >
        {text}
      </MolsonTypography>
      {icon ?? null}
      {children ?? null}
    </MolsonButton>
  )
}
